import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { LinkButton } from "@/components/LinkButton";

import { IInspectorColumnedItem } from "./types";

type IProps = IInspectorColumnedItem;

export const Item: React.FC<IProps> = ({
  title,
  description,
  images,
  imageBgStyle,
  rightSidedImage = false,
  button,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  return (
    <>
      <div
        className={css({
          position: "relative",
          [bp.FROM_TABLET]: {
            gridColumn: rightSidedImage ? "2 / -1" : "1 / 2",
          },
        })}
      >
        <div className={css({ ...imageBgStyle })} />
        {images.map(imageProps => (
          <Image key={imageProps.alt} {...imageProps} />
        ))}
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          [bp.FROM_TABLET]: {
            gridColumn: rightSidedImage ? "1 / 2" : "2 / -1",
            alignItems: rightSidedImage ? "flex-start" : "flex-end",
          },
        })}
      >
        <div
          className={css({
            [bp.FROM_TABLET]: {
              maxWidth: 470,
            },
          })}
        >
          <Heading
            as="h3"
            customStyle={{
              fontSize: 28,
              lineHeight: "32px",
              color: colors.DARK_GREY,
              fontWeight: 700,
              marginBottom: 16,
              [bp.FROM_DESKTOP]: {
                fontSize: 36,
                lineHeight: "46px",
              },
            }}
          >
            {title}
          </Heading>

          <p
            className={css({
              fontSize: 16,
              lineHeight: "24px",
              color: colors.GRAY,
            })}
          >
            {description}
          </p>

          {button && (
            <div className={css({ display: "flex", flexDirection: "row" })}>
              <LinkButton
                href={button.href}
                customStyle={{
                  padding: "10px 24px",
                  backgroundColor: colors.ORANGE,
                  color: colors.WHITE,
                  marginTop: 32,
                  marginBottom: 0,
                  width: "auto",
                }}
                title={button.label}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
